import client from './client';

export const listStreetAliases = (params) =>
  client.get('/street-aliases', { params }).then((r) => r.data);

export const createStreetAlias = (data) =>
  client.post('/street-aliases', data).then((r) => r.data);

export const updateStreetAlias = (id, data) =>
  client.put(`/street-aliases/${id}`, data).then((r) => r.data);

export const deleteStreetAlias = (id) =>
  client.delete(`/street-aliases/${id}`).then((r) => r.data);
